<template>
  <div class="psStore">
    <div class="select">
      <el-form ref="form" :model="request" label-position="right">
        <el-form-item><el-input v-model="request.storeName" placeholder="门店名称" style="width:200px" clearable></el-input></el-form-item>
        <el-form-item><el-input v-model="request.phone" placeholder="门店联系电话" style="width:200px" clearable></el-input></el-form-item>
         <el-form-item>
            <el-select v-model="request.province" clearable placeholder="省" @change="provinceChoose" style="width:160px">
              <el-option v-for="item in this.province" :key="item.code" :label="item.value" :value="item.code" ></el-option>
            </el-select>
            <el-select v-model="request.city" clearable placeholder="市" @change="cityChoose" style="width:160px">
              <el-option v-for="item in this.city" :key="item.code" :label="item.value" :value="item.code"></el-option>
            </el-select>
            <el-select v-model="request.area" clearable placeholder="区" style="width:160px">
              <el-option v-for="item in this.area" :key="item.code" :label="item.value" :value="item.code"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getPsStore">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableData">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                style="margin:auto;width:calc(100% - 30px)" height="745" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="门店编号" width="150" align="center" prop="code"></el-table-column>
        <el-table-column label="门店名称" width="200" align="center" prop="name"></el-table-column>
        <el-table-column label="门店单价" width="150" align="center" prop="">
          <template slot-scope="scope">{{ scope.row.unitPrice }}/ {{ scope.row.sku }}</template>
        </el-table-column>
        <el-table-column label="封顶价格" width="100" align="center" prop="maxPrice"></el-table-column>
        <el-table-column label="所在地区" width="200" align="center">
          <template slot-scope="scope">
            {{ scope.row.provinceStr }}{{ scope.row.cityStr
            }}{{ scope.row.areaStr }}
          </template>
        </el-table-column>
        <el-table-column label="详细地址" width="500" align="center" prop="address"></el-table-column>
        <el-table-column label="门店品类" width="200" align="center">
          <template slot-scope="scope">{{ scope.row.categoryStr }}/{{ scope.row.subCategoryStr }}</template>
        </el-table-column>
        <el-table-column label="联系人姓名" width="100" align="center" prop="contactName"></el-table-column>
        <el-table-column label="联系人电话" width="150" align="center" prop="contactPhone"></el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button  type="danger" plain @click="psStoreDetail(scope.row.id)" size="small">详情</el-button>
            <el-button  type="danger" plain @click="modifyStore(scope.row.id)" size="small">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    </div>
    <ps-store-detail v-if="psStoreDetailDialog" ref="psStoreDetail"></ps-store-detail>
    <modify-store v-if="modifyStoreDialog" ref="modifyStore" @modify-succeed="modifySucceed"></modify-store>
  </div>
</template>

<script>
import { getAllPsStore } from "../../api/storemanagement/psstore.js";
import { formatDate } from "../../utils/date";
import PsStoreDetail from './psStoreDetail.vue';
import ModifyStore from './modifyStore.vue'
export default {
  components: { PsStoreDetail ,ModifyStore},
  name: "PsStore",
  data() {
    return {
      request: {
        storeName: '',
        phone: '',
        csName: '',
        csPhone: '',
        province: '',
        city: '',
        area: '',
        current: '',
        size: ''
      },
      global: '',
      province: '',
      city: '',
      area: '',
      loading: false,
      query: {current: 1,size: 15},
      response: {data: [],total: 0},
      psStoreDetailDialog: false,
      modifyStoreDialog: false
    }
  },
  methods: {
    /**
     * 获取门店列表
     */
    getPsStore() {
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      getAllPsStore(this.request).then((result) => {
        this.response.data = result.data.records;
        this.response.total = result.data.total;
      });
    },

    /**
     * 页码改变触发事件
     */
    currenChangeHandle(value) {
      this.query.current = value;
      this.getPsStore()
    },

    /**
    * 省下拉框选择触发事件
    */
    provinceChoose(value){
      this.request.city = '';
      this.request.area = '';
      for (let item of this.province) {
        if (value == item.code) {
          this.city = item.childrenDictList
        }
      }  
    },

    /**
    * 市下拉框选择触发事件
    */
    cityChoose(value){
      this.request.area = '';
      for (let item of this.city) {
        if (value == item.code) {
          this.area = item.childrenDictList;
        }
      }
    },

    /**
    * 门店详情
    */
    psStoreDetail(value){
      this.psStoreDetailDialog = true;
      this.$nextTick(() =>{
        this.$refs.psStoreDetail.init(value);
      })
    },

    /**
     * 编辑门店
     */
    modifyStore(value){
      this.modifyStoreDialog = true;
      this.$nextTick(() =>{
        this.$refs.modifyStore.init(value);
      })
    },

    /**
     * 监听组件
     */
    modifySucceed(){
      this.getPsStore();
    },

    /**
     * 重置
     */
    reset(){
      this.request.storeName = "";
      this.request.phone = "";
      this.request.csName = "";
      this.request.csPhone = "";
      this.request.province = "";
      this.request.city = "";
      this.request.area = "";
      this.query.current = 1;
      this.getPsStore();
    }
  },
  created() {
    this.global = JSON.parse(sessionStorage.getItem("global"));
    this.province = JSON.parse(sessionStorage.getItem("dict")).area;
    this.getPsStore();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>
<style scoped>
.psStore {
  width: 100%;
  height: 100%;
}

.el-form {
  float: left;
}

.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/storemanagement/psstore.vue